import { render, staticRenderFns } from "./levelStatistics.vue?vue&type=template&id=1948b42a&"
import script from "./levelStatistics.vue?vue&type=script&lang=js&"
export * from "./levelStatistics.vue?vue&type=script&lang=js&"
import style0 from "./levelStatistics.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports